import styled from "styled";
import { ReactComponent as JoinUniformSvg } from "./joinUniform.svg";

/** Site logo image, takes up 100% of container by default. */
export const LogoImage = styled(JoinUniformSvg)`
  width: 100%;
  height: 100%;
`;
